import React, { useState, useEffect, useContext } from 'react';
import { AudioContext } from '../context/AudioContext';

const History = () => {
    const [history, setHistory] = useState([]);
    const { setCurrentChannel } = useContext(AudioContext);

    useEffect(() => {
        const storedHistory = sessionStorage.getItem('radioHistory');
        if (storedHistory) {
            setHistory(JSON.parse(storedHistory));
        }
    }, []);

    const playChannel = (channel) => {
        setCurrentChannel(channel);

        // Update history
        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length) updatedHistory.pop(); // Limit history to 5 items

        setHistory(updatedHistory);
        sessionStorage.setItem('radioHistory', JSON.stringify(updatedHistory));
    };

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title">
                            <h2>Listening History</h2>
                        </div>
                    </div>

                    {history.length === 0 ? (
                        <div className="col-12">
                            <p>No history found.</p>
                        </div>
                    ) : (
                        history.map((channel) => (
                            <div className="col-6 col-sm-4 col-lg-2"  key={channel.id} onClick={() => playChannel(channel)}>
                                <div className="album">
                                    <div className="album__cover">
                                        <img src={channel.favicon} alt={`${channel.name} logo`} />
                                        <a href="#" onClick={() => playChannel(channel)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                            </svg>
                                        </a>
                                    </div>
                                    <div className="album__title">
                                        <h3>{channel.name}</h3>
                                        <span>{channel.language}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>
        </main>
    );
};

export default History;
